import { render, staticRenderFns } from "./EssaySearch.vue?vue&type=template&id=4c99f672&scoped=true"
import script from "./EssaySearch.vue?vue&type=script&lang=js"
export * from "./EssaySearch.vue?vue&type=script&lang=js"
import style0 from "./EssaySearch.vue?vue&type=style&index=0&id=4c99f672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99f672",
  null
  
)

export default component.exports